import BrowserCheck from '../../lib/components/browser_check'

export function setupBrowserCheck (opts, app) {
  const model = new Backbone.Model()
  const browserCheck = new BrowserCheck({
    model,
    mode: opts.mode,
    appName: opts.appName
  })

  // respond appropriately to status change
  model.on('change:status', (model, status) => {
    switch (status) {
      case 'unsupported':
        $('body').append(browserCheck.$el)

        // turn down app to prevent continuing
        app.remove()
        break

      case 'warning':
        $('body').append(browserCheck.$el)
        break
    }
  })

  // start checker
  browserCheck.check()
}
